import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { useWindowSize } from "../../../../../Helpers";
import Button from "@components/Button";
import "./style.scss";
import LinearGradientProgressBar from "@components/LinearGradientProgressBar";
import StickyButton from "../../../../../components/StickyButton";
import PagesHeader from "@components/PagesHeader";
import StickyContent from "@components/StickyContent";
import BrandLogo from "@components/BrandLogo";
import NiceModal from "@ebay/nice-modal-react";
import DOMPurify from "dompurify";

export default function Match({
  currentQuestion,
  setCurrentQuestion,
  setAnswers,
  answers,
  sendAnswers,
}) {
  const { ident } = useParams();
  const { width } = useWindowSize();
  const queryClient = useQueryClient();
  const gameQuestionsQuery = queryClient.getQueryData([
    "game-questions",
    ident,
  ]);
  const XGA = width >= 1020;
  const [firstClick, setFirstClick] = useState(null);
  const [firstClickIndex, setFirstClickIndex] = useState(null);
  const [secondClick, setSecondClick] = useState(null);
  const [match, setMatch] = useState([]);
  const [selected, setSelected] = useState();
  const [selectedAnswerCopyTitle, setSelectedAnswerCopyTitle] = useState("");

  const isUltraInsider =
    location.pathname.includes("/ultra-insider") ||
    location.pathname.includes("/ultrainsider");

  const handleAnswerClick = (index) => {
    const selectedPair =
      gameQuestionsQuery.content[currentQuestion].answers[index].pair;

    setSelectedAnswerCopyTitle(
      gameQuestionsQuery.content[currentQuestion]?.answers[index].copyTitle
    );

    if (firstClick === null) {
      setSelected(
        gameQuestionsQuery.content[currentQuestion].answers[index].uuid
      );
      setFirstClick(selectedPair);
      setFirstClickIndex(index);
    } else if (index !== firstClickIndex) {
      setSecondClick(selectedPair);
    }
  };

  useEffect(() => {
    if (firstClick !== null && secondClick !== null) {
      if (firstClick === secondClick) {
        setMatch((prevMatch) => [...prevMatch, firstClick]);
        if (selectedAnswerCopyTitle) {
          NiceModal.show("correct-answer", {
            copyTitle: selectedAnswerCopyTitle,
          });
        }
      }
      setSelected(null);
      setFirstClick(null);
      setFirstClickIndex(null);
      setSecondClick(null);
    }
    if (firstClick !== null) {
      if (firstClick.includes("self")) {
        setMatch((prevMatch) => [...prevMatch, firstClick]);
        if (selectedAnswerCopyTitle) {
          NiceModal.show("correct-answer", {
            copyTitle: selectedAnswerCopyTitle,
          });
        }
        setSelected(null);
        setFirstClick(null);
        setFirstClickIndex(null);
        setSecondClick(null);
      }
    }
  }, [firstClick, secondClick]);

  const handleNextButtonClick = () => {
    setAnswers((prev) => [
      ...prev,
      {
        question_ident: `q${currentQuestion}`,
        answer_ident: "",
      },
    ]);
    setCurrentQuestion((prev) =>
      prev <= gameQuestionsQuery.content.length - 1 ? ++prev : prev
    );
    setMatch([]);
  };

  return (
    <section
      className={`game-page match-mechanics ${ident} ${
        isUltraInsider ? "ultra-insider" : ""
      }`}
    >
      <div>
        <PagesHeader back>
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(gameQuestionsQuery?.title),
            }}
          ></p>
        </PagesHeader>
        <div className="main-game-wrppaer-match">
          <div className="desktop-wrapper">
            <LinearGradientProgressBar
              value={
                gameQuestionsQuery.content[currentQuestion].selfMatch
                  ? match.length /
                    gameQuestionsQuery.content[currentQuestion].answers.length
                  : match.length /
                    (gameQuestionsQuery.content[currentQuestion].answers
                      .length /
                      2)
              }
            />
            <div className="game-question">
              <h2
                className="question"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion].question),
                }}
              />
            </div>
            <div className="answer-content">
              <div className="answers-wrapper">
                {gameQuestionsQuery.content[currentQuestion].answers.map(
                  (element, index) => (
                    <button
                      disabled={match.includes(element.pair)}
                      key={index}
                      className={`tile ${
                        selected === element.uuid
                          ? "active"
                          : "" || match.includes(element.pair)
                          ? "match"
                          : ""
                      }`}
                      onClick={() => {
                        handleAnswerClick(index);
                      }}
                    >
                      <div className="tile-inner">
                        {element.img ? (
                          <img
                            src={element.img}
                            alt=""
                            className="tile-img"
                          />
                        ) : null}
                        {element.copy ? (
                          <p
                            className="tile-copy"
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(element.copy),
                            }}
                          />
                        ) : null}
                      </div>
                    </button>
                  )
                )}
              </div>
            </div>
          </div>
          <div className="side-img">
            {XGA && <BrandLogo brands={gameQuestionsQuery?.brands} />}
            {gameQuestionsQuery.content[currentQuestion].desktopImgHid ? (
              selected ===
              gameQuestionsQuery.content[currentQuestion].correctAnswer ? (
                <img
                  src={
                    gameQuestionsQuery.content[currentQuestion][
                      width < 1020 ? "mobileImg" : "desktopImg"
                    ]
                  }
                  alt=""
                />
              ) : (
                <img
                  src={
                    gameQuestionsQuery.content[currentQuestion][
                      width < 1020 ? "mobileImgHid" : "desktopImgHid"
                    ]
                  }
                  alt=""
                />
              )
            ) : (
              <img
                src={
                  gameQuestionsQuery.content[currentQuestion][
                    width < 1020 ? "" : "desktopImg"
                  ]
                }
                alt=""
              />
            )}
            {XGA && (
              <StickyContent>
                <div className="desktop-buttons">
                  <Button
                    disabled={
                      gameQuestionsQuery.content[currentQuestion].selfMatch
                        ? match.length !==
                          gameQuestionsQuery.content[currentQuestion].answers
                            .length
                        : match.length !==
                          gameQuestionsQuery.content[currentQuestion].answers
                            .length /
                            2
                    }
                    action={handleNextButtonClick}
                  >
                    {gameQuestionsQuery.content[currentQuestion]
                      .nextButtonCopy ?? "Nächste"}
                  </Button>
                </div>
              </StickyContent>
            )}
          </div>
        </div>
      </div>
      {!XGA && (
        <StickyButton
          disabled={
            gameQuestionsQuery.content[currentQuestion].selfMatch
              ? match.length !==
                gameQuestionsQuery.content[currentQuestion].answers.length
              : match.length !==
                gameQuestionsQuery.content[currentQuestion].answers.length / 2
          }
          action={handleNextButtonClick}
        >
          {gameQuestionsQuery.content[currentQuestion].nextButtonCopy ??
            "Nächste"}
        </StickyButton>
      )}
    </section>
  );
}
